import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
  })

export async function crudUsersApi({comando, regId=null, token='', data=null}) {

    //console.log('crudUsersApi: ', {comando, token, data});

    const headers = token ? { 'content-type':'application/json', authorization: `Bearer ${token}`}
                          : { 'content-type':'application/json'}

    const body = {comando, token, data};
    
    try{
        const response = await axiosInstance.post('/user/crudUsers', body, {
            headers: headers
        })
        //console.log ("response.data", response.data);
        return response.data;
    } catch(error){
        //console.log (error);
        //console.log (error.response.data.message);
        throw new Error (error.response.data.message);
    }
}